import { MatDialogRef } from '@angular/material/dialog';
import { DashboardEventService } from './../../dashboard/dashboard-event.service';
import { AppConfig } from './../../app.config';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import * as moment from 'moment';

@Component({
    selector: 'app-switch-date',
    templateUrl: './switch-date.component.html',
    styleUrls: ['./switch-date.component.css']
})
export class SwitchDateComponent implements OnInit {
    // date: FormControl;
    date: Date;
    switchResult: string;
    asOfDateMode: boolean;
    minDateValue: Date;
    maxDateValue: Date;

    constructor(private appConfig: AppConfig,
        private dashboardEventService: DashboardEventService,
        public dialogRef: MatDialogRef<SwitchDateComponent>) {
        this.date = new Date();
        this.minDateValue = moment(this.date).subtract(7, 'days').toDate();
        this.maxDateValue = this.date;
    }

    ngOnInit() {
        this.asOfDateMode = this.appConfig.asOfDateMode;
    }

    confirm() {
        // const newDate = this.date.value;
        if (this.date) {
            this.dashboardEventService.restartSubject.next(this.date);
        }
        this.dialogRef.close();
    }

    returnToLive() {
        this.dashboardEventService.restartLive();
        this.dialogRef.close();
    }
}
